module.exports = __webpack_public_path__ + "static/media/status-badge-basic.e92dd452.svg";